<template>
<pre class="mt-5" v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            return hljs.highlight(`${JSON.stringify(this.attribute.value, null, "  ")}`, {language: 'json'}).value
        }
    }

}
</script>